export function loadScript(onload, { id, src, async = false, defer = false }) {
  const script = document.createElement('script')
  const scriptDom = document.getElementById(id)
  if (scriptDom) {
    return
  }
  script.id = id
  script.src = src
  script.async = async
  script.defer = defer
  script.onload = onload
  window.document.head.appendChild(script)
}
